module.exports = __webpack_public_path__ + "img/infoPopup.8b98fdfd.svg";